webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1436)

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1373),
  /* template */
  __webpack_require__(1700),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1357:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(64);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].cordova.on('deviceready', function () {
      _this.$store.commit('cordova', true);
      document.addEventListener("backbutton", function (e) {
        // e.preventDefault()
        window.history.back();
      });
      Keyboard.shrinkView(true);
      window.open = cordova.InAppBrowser.open;
    });
  }
});

/***/ }),

/***/ 1358:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_firebaseinit__ = __webpack_require__(24);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "my-list",
  data: function data() {
    return {

      CurrentContent: [],

      books: [],
      courseSwiper: {

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        // Disable preloading of all images
        preloadImages: false,

        // Enable lazy loading
        lazy: true,
        // loadPrevNext: true,
        // loadPrevNextAmount: 10,
        slidesPerView: 'auto',
        spaceBetween: 20,
        speed: 1000,

        watchSlidesVisibility: true,

        freeMode: true,
        freeModeMomentum: true,
        freeModeMomentumRatio: 0.2,
        freeModeMomentumVelocityRatio: 1.0,
        freeModeMomentumBounce: true,
        freeModeSticky: true,
        freeModeMinimumVelocity: 0.08,

        preventClicks: false,

        touchRatio: 1,
        longSwipesRatio: 0.4,

        noSwiping: false,

        breakpoints: {
          768: {
            spaceBetween: 20
          },
          576: {
            spaceBetween: 20
          },
          320: {
            spaceBetween: 15
          }
        }
      }
    };
  },

  computed: {
    Currentbooks: function Currentbooks() {
      for (var i = 0; i < this.$store.state.FixedShow + 1; i++) // push extra so that, it will give more space for view more image
      {
        this.CurrentContent.push(books[i]);
      }
      return this.CurrentContent;
    }
  },

  methods: {
    handleBook: function handleBook(e) {
      this.$router.push({
        name: 'viewContent'
      });
      if (!e) e = window.event;
      var x = e.currentTarget;
      var book_id = x.id;
      localStorage.setItem('book', book_id);

      //this.$store.dispatch('setBookName', book_id);
    },

    handleViewAll: function handleViewAll() {
      //this.$store.state.ChooseGridView = "novel";
      localStorage.setItem('viewAll', "Magazine");
      this.$router.push({
        name: "ViewAll"
      });
    }
  },

  //database
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__firebase_firebaseinit__["a" /* default */].collection('books').orderBy('bookName').get().then(function (query) {
      query.forEach(function (doc) {
        if (doc.data().bookType == "Magazine") {
          var data = {
            id: doc.id,
            bookId: doc.data().bookId,
            bookName: doc.data().bookName,
            bookType: doc.data().bookType,
            datePublished: doc.data().datePublished,
            flowpaper: doc.data().flowpaper,
            genre: doc.data().genre,
            imgLink: doc.data().imgLink,
            language: doc.data().language,
            rating: doc.data().rating,
            reviews: doc.data().reviews
          };
          _this.books.push(data);
        }
      });

      for (var i = 0; i < _this.$store.state.FixedShow + 1; i++) // push extra so that, it will give more space for view more image
      {
        _this.CurrentContent.push(_this.books[i]);
      }
    });
  }
});

/***/ }),

/***/ 1359:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_firebaseinit__ = __webpack_require__(24);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "my-list",
  data: function data() {
    return {

      CurrentContent: [],

      books: [],
      courseSwiper: {

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        // Disable preloading of all images
        preloadImages: false,

        // Enable lazy loading
        lazy: true,
        // loadPrevNext: true,
        // loadPrevNextAmount: 10,
        slidesPerView: 'auto',
        spaceBetween: 20,
        speed: 1000,

        watchSlidesVisibility: true,

        freeMode: true,
        freeModeMomentum: true,
        freeModeMomentumRatio: 0.2,
        freeModeMomentumVelocityRatio: 1.0,
        freeModeMomentumBounce: true,
        freeModeSticky: true,
        freeModeMinimumVelocity: 0.08,

        preventClicks: false,

        touchRatio: 1,
        longSwipesRatio: 0.4,

        noSwiping: false,

        breakpoints: {
          768: {
            spaceBetween: 20
          },
          576: {
            spaceBetween: 20
          },
          320: {
            spaceBetween: 15
          }
        }
      }
    };
  },

  computed: {
    Currentbooks: function Currentbooks() {
      for (var i = 0; i < this.$store.state.FixedShow + 1; i++) // push extra so that, it will give more space for view more image
      {
        this.CurrentContent.push(books[i]);
      }
      return this.CurrentContent;
    }
  },

  methods: {
    handleBook: function handleBook(e) {
      this.$router.push({
        name: 'viewContent'
      });
      if (!e) e = window.event;
      var x = e.currentTarget;
      var book_id = x.id;
      localStorage.setItem('book', book_id);

      //this.$store.dispatch('setBookName', book_id);
    },

    handleViewAll: function handleViewAll() {
      //this.$store.state.ChooseGridView = "novel";
      localStorage.setItem('viewAll', "Novel");
      this.$router.push({
        name: "ViewAll"
      });
    }
  },

  //database
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__firebase_firebaseinit__["a" /* default */].collection('books').where('bookType', '==', "Novel").get().then(function (query) {
      query.forEach(function (doc) {
        var data = {
          id: doc.id,
          bookId: doc.data().bookId,
          bookName: doc.data().bookName,
          bookType: doc.data().bookType,
          datePublished: doc.data().datePublished,
          genre: doc.data().genre,
          language: doc.data().language,
          description: doc.data().description
        };
        _this.books.push(data);
      });

      for (var i = 0; i < _this.$store.state.FixedShow + 1; i++) // push extra so that, it will give more space for view more image
      {
        _this.CurrentContent.push(_this.books[i]);
      }
    });
  }
});

/***/ }),

/***/ 1360:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_firebaseinit__ = __webpack_require__(24);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "my-list",
  data: function data() {
    return {

      CurrentContent: [],

      books: [],
      courseSwiper: {

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        // Disable preloading of all images
        preloadImages: false,

        // Enable lazy loading
        lazy: true,
        // loadPrevNext: true,
        // loadPrevNextAmount: 10,
        slidesPerView: 'auto',
        spaceBetween: 20,
        speed: 1000,

        watchSlidesVisibility: true,

        freeMode: true,
        freeModeMomentum: true,
        freeModeMomentumRatio: 0.2,
        freeModeMomentumVelocityRatio: 1.0,
        freeModeMomentumBounce: true,
        freeModeSticky: true,
        freeModeMinimumVelocity: 0.08,

        preventClicks: false,

        touchRatio: 1,
        longSwipesRatio: 0.4,

        noSwiping: false,

        breakpoints: {
          768: {
            spaceBetween: 20
          },
          576: {
            spaceBetween: 20
          },
          320: {
            spaceBetween: 15
          }
        }
      }
    };
  },

  computed: {
    Currentbooks: function Currentbooks() {
      for (var i = 0; i < this.$store.state.FixedShow + 1; i++) // push extra so that, it will give more space for view more image
      {
        this.CurrentContent.push(books[i]);
      }
      return this.CurrentContent;
    }
  },

  methods: {
    handleBook: function handleBook(e) {
      this.$router.push({
        name: 'viewContent'
      });
      if (!e) e = window.event;
      var x = e.currentTarget;
      var book_id = x.id;
      localStorage.setItem('book', book_id);

      //this.$store.dispatch('setBookName', book_id);
    },

    handleViewAll: function handleViewAll() {
      //this.$store.state.ChooseGridView = "novel";
      localStorage.setItem('viewAll', "Agama");
      this.$router.push({
        name: "ViewAll"
      });
    }
  },

  //database
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__firebase_firebaseinit__["a" /* default */].collection('books').where('bookType', '==', "Agama").get().then(function (query) {
      query.forEach(function (doc) {
        var data = {
          id: doc.id,
          bookId: doc.data().bookId,
          bookName: doc.data().bookName,
          bookType: doc.data().bookType,
          datePublished: doc.data().datePublished,
          genre: doc.data().genre,
          language: doc.data().language,
          description: doc.data().description
        };
        _this.books.push(data);
      });

      for (var i = 0; i < _this.$store.state.FixedShow + 1; i++) // push extra so that, it will give more space for view more image
      {
        _this.CurrentContent.push(_this.books[i]);
      }
    });
  }
});

/***/ }),

/***/ 1361:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_firebaseinit__ = __webpack_require__(24);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "my-list",
  data: function data() {
    return {

      CurrentContent: [],

      books: [],
      courseSwiper: {

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        // Disable preloading of all images
        preloadImages: false,

        // Enable lazy loading
        lazy: true,
        // loadPrevNext: true,
        // loadPrevNextAmount: 10,
        slidesPerView: 'auto',
        spaceBetween: 20,
        speed: 1000,

        watchSlidesVisibility: true,

        freeMode: true,
        freeModeMomentum: true,
        freeModeMomentumRatio: 0.2,
        freeModeMomentumVelocityRatio: 1.0,
        freeModeMomentumBounce: true,
        freeModeSticky: true,
        freeModeMinimumVelocity: 0.08,

        preventClicks: false,

        touchRatio: 1,
        longSwipesRatio: 0.4,

        noSwiping: false,

        breakpoints: {
          768: {
            spaceBetween: 20
          },
          576: {
            spaceBetween: 20
          },
          320: {
            spaceBetween: 15
          }
        }
      }
    };
  },

  computed: {
    Currentbooks: function Currentbooks() {
      for (var i = 0; i < this.$store.state.FixedShow + 1; i++) // push extra so that, it will give more space for view more image
      {
        this.CurrentContent.push(books[i]);
      }
      return this.CurrentContent;
    }
  },

  methods: {
    handleBook: function handleBook(e) {
      this.$router.push({
        name: 'viewContent'
      });
      if (!e) e = window.event;
      var x = e.currentTarget;
      var book_id = x.id;
      localStorage.setItem('book', book_id);

      //this.$store.dispatch('setBookName', book_id);
    },

    handleViewAll: function handleViewAll() {
      //this.$store.state.ChooseGridView = "novel";
      localStorage.setItem('viewAll', "Bukan Fiksyen");
      this.$router.push({
        name: "ViewAll"
      });
    }
  },

  //database
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__firebase_firebaseinit__["a" /* default */].collection('books').where('bookType', '==', "Bukan Fiksyen").get().then(function (query) {
      query.forEach(function (doc) {
        var data = {
          id: doc.id,
          bookId: doc.data().bookId,
          bookName: doc.data().bookName,
          bookType: doc.data().bookType,
          datePublished: doc.data().datePublished,
          genre: doc.data().genre,
          language: doc.data().language,
          description: doc.data().description
        };
        _this.books.push(data);
      });

      for (var i = 0; i < _this.$store.state.FixedShow + 1; i++) // push extra so that, it will give more space for view more image
      {
        _this.CurrentContent.push(_this.books[i]);
      }
    });
  }
});

/***/ }),

/***/ 1362:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_firebaseinit__ = __webpack_require__(24);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "my-list",
  data: function data() {
    return {

      CurrentContent: [],

      books: [],
      courseSwiper: {

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        // Disable preloading of all images
        preloadImages: false,

        // Enable lazy loading
        lazy: true,
        // loadPrevNext: true,
        // loadPrevNextAmount: 10,
        slidesPerView: 'auto',
        spaceBetween: 20,
        speed: 1000,

        watchSlidesVisibility: true,

        freeMode: true,
        freeModeMomentum: true,
        freeModeMomentumRatio: 0.2,
        freeModeMomentumVelocityRatio: 1.0,
        freeModeMomentumBounce: true,
        freeModeSticky: true,
        freeModeMinimumVelocity: 0.08,

        preventClicks: false,

        touchRatio: 1,
        longSwipesRatio: 0.4,

        noSwiping: false,

        breakpoints: {
          768: {
            spaceBetween: 20
          },
          576: {
            spaceBetween: 20
          },
          320: {
            spaceBetween: 15
          }
        }
      }
    };
  },

  computed: {
    Currentbooks: function Currentbooks() {
      for (var i = 0; i < this.$store.state.FixedShow + 1; i++) // push extra so that, it will give more space for view more image
      {
        this.CurrentContent.push(books[i]);
      }
      return this.CurrentContent;
    }
  },

  methods: {
    handleBook: function handleBook(e) {
      this.$router.push({
        name: 'viewContent'
      });
      if (!e) e = window.event;
      var x = e.currentTarget;
      var book_id = x.id;
      localStorage.setItem('book', book_id);

      //this.$store.dispatch('setBookName', book_id);
    },

    handleViewAll: function handleViewAll() {
      //this.$store.state.ChooseGridView = "novel";
      localStorage.setItem('viewAll', "Kanak-Kanak");
      this.$router.push({
        name: "ViewAll"
      });
    }
  },

  //database
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__firebase_firebaseinit__["a" /* default */].collection('books').where('bookType', '==', "Kanak-Kanak").get().then(function (query) {
      query.forEach(function (doc) {
        var data = {
          id: doc.id,
          bookId: doc.data().bookId,
          bookName: doc.data().bookName,
          bookType: doc.data().bookType,
          datePublished: doc.data().datePublished,
          genre: doc.data().genre,
          language: doc.data().language,
          description: doc.data().description
        };
        _this.books.push(data);
      });

      for (var i = 0; i < _this.$store.state.FixedShow + 1; i++) // push extra so that, it will give more space for view more image
      {
        _this.CurrentContent.push(_this.books[i]);
      }
    });
  }
});

/***/ }),

/***/ 1363:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_firebaseinit__ = __webpack_require__(24);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "my-list",
  data: function data() {
    return {

      CurrentContent: [],

      books: [],
      courseSwiper: {

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        // Disable preloading of all images
        preloadImages: false,

        // Enable lazy loading
        lazy: true,
        // loadPrevNext: true,
        // loadPrevNextAmount: 10,
        slidesPerView: 'auto',
        spaceBetween: 20,
        speed: 1000,

        watchSlidesVisibility: true,

        freeMode: true,
        freeModeMomentum: true,
        freeModeMomentumRatio: 0.2,
        freeModeMomentumVelocityRatio: 1.0,
        freeModeMomentumBounce: true,
        freeModeSticky: true,
        freeModeMinimumVelocity: 0.08,

        preventClicks: false,

        touchRatio: 1,
        longSwipesRatio: 0.4,

        noSwiping: false,

        breakpoints: {
          768: {
            spaceBetween: 20
          },
          576: {
            spaceBetween: 20
          },
          320: {
            spaceBetween: 15
          }
        }
      }
    };
  },

  computed: {
    magazines: function magazines() {
      for (var i = 0; i < this.$store.state.FixedShow + 1; i++) // push extra so that, it will give more space for view more image
      {
        this.CurrentContent.push(books[i]);
      }
      return this.CurrentContent;
    }
  },

  methods: {
    handleBook: function handleBook(e) {
      this.$router.push({
        name: 'viewContent'
      });
      if (!e) e = window.event;
      var x = e.currentTarget;
      var book_id = x.id;
      localStorage.setItem('book', book_id);

      //this.$store.dispatch('setBookName', book_id);
    },

    handleViewAll: function handleViewAll() {
      //this.$store.state.ChooseGridView = "children";
      localStorage.setItem('viewAll', "Children");
      this.$router.push({
        name: "ViewAll"
      });
    }
  },

  //database
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__firebase_firebaseinit__["a" /* default */].collection('books').where('bookType', '==', "Children").get().then(function (query) {
      query.forEach(function (doc) {
        var data = {
          id: doc.id,
          bookId: doc.data().bookId,
          bookName: doc.data().bookName,
          bookType: doc.data().bookType,
          datePublished: doc.data().datePublished,
          genre: doc.data().genre,
          language: doc.data().language,
          description: doc.data().description
        };
        _this.books.push(data);
      });
      for (var i = 0; i < _this.$store.state.FixedShow + 1; i++) // push extra so that, it will give more space for view more image
      {
        _this.CurrentContent.push(_this.books[i]);
      }
    });
  }
});

/***/ }),

/***/ 1364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_firebaseinit__ = __webpack_require__(24);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "my-list",
  data: function data() {
    return {

      CurrentContent: [],

      books: [],
      courseSwiper: {

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        // Disable preloading of all images
        preloadImages: false,

        // Enable lazy loading
        lazy: true,
        // loadPrevNext: true,
        // loadPrevNextAmount: 10,
        slidesPerView: 'auto',
        spaceBetween: 20,
        speed: 1000,

        watchSlidesVisibility: true,

        freeMode: true,
        freeModeMomentum: true,
        freeModeMomentumRatio: 0.2,
        freeModeMomentumVelocityRatio: 1.0,
        freeModeMomentumBounce: true,
        freeModeSticky: true,
        freeModeMinimumVelocity: 0.08,

        preventClicks: false,

        touchRatio: 1,
        longSwipesRatio: 0.4,

        noSwiping: false,

        breakpoints: {
          768: {
            spaceBetween: 20
          },
          576: {
            spaceBetween: 20
          },
          320: {
            spaceBetween: 15
          }
        }
      }
    };
  },

  computed: {
    magazines: function magazines() {
      for (var i = 0; i < this.$store.state.FixedShow + 1; i++) // push extra so that, it will give more space for view more image
      {
        this.CurrentContent.push(books[i]);
      }
      return this.CurrentContent;
    }
  },

  methods: {
    handleBook: function handleBook(e) {
      this.$router.push({
        name: 'viewContent'
      });
      if (!e) e = window.event;
      var x = e.currentTarget;
      var book_id = x.id;
      localStorage.setItem('book', book_id);

      //this.$store.dispatch('setBookName', book_id);
    },

    handleViewAll: function handleViewAll() {
      //this.$store.state.ChooseGridView = "magazine";
      localStorage.setItem('viewAll', "Magazine");
      this.$router.push({
        name: "ViewAll"
      });
    }
  },

  //database
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__firebase_firebaseinit__["a" /* default */].collection('books').orderBy('bookName').get().then(function (query) {
      //.where('bookType','==', "Magazine")
      query.forEach(function (doc) {
        if (doc.data().bookType == "Magazine") {
          var data = {
            id: doc.id,
            bookId: doc.data().bookId,
            bookName: doc.data().bookName,
            bookType: doc.data().bookType,
            datePublished: doc.data().datePublished,
            flowpaper: doc.data().flowpaper,
            genre: doc.data().genre,
            imgLink: doc.data().imgLink,
            language: doc.data().language,
            rating: doc.data().rating,
            reviews: doc.data().reviews
          };
          _this.books.push(data);
        }
      });

      for (var i = 0; i < _this.$store.state.FixedShow + 1; i++) // push extra so that, it will give more space for view more image
      {
        _this.CurrentContent.push(_this.books[i]);
      }
    });
  }
});

/***/ }),

/***/ 1365:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_firebaseinit__ = __webpack_require__(24);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "my-list",
  data: function data() {
    return {

      CurrentContent: [],

      books: [],
      courseSwiper: {

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        // Disable preloading of all images
        preloadImages: false,

        // Enable lazy loading
        lazy: true,
        // loadPrevNext: true,
        // loadPrevNextAmount: 10,
        slidesPerView: 'auto',
        spaceBetween: 20,
        speed: 1000,

        watchSlidesVisibility: true,

        freeMode: true,
        freeModeMomentum: true,
        freeModeMomentumRatio: 0.2,
        freeModeMomentumVelocityRatio: 1.0,
        freeModeMomentumBounce: true,
        freeModeSticky: true,
        freeModeMinimumVelocity: 0.08,

        preventClicks: false,

        touchRatio: 1,
        longSwipesRatio: 0.4,

        noSwiping: false,

        breakpoints: {
          768: {
            spaceBetween: 20
          },
          576: {
            spaceBetween: 20
          },
          320: {
            spaceBetween: 15
          }
        }
      }
    };
  },

  computed: {
    Currentbooks: function Currentbooks() {
      for (var i = 0; i < this.$store.state.FixedShow + 1; i++) // push extra so that, it will give more space for view more image
      {
        this.CurrentContent.push(books[i]);
      }
      return this.CurrentContent;
    }
  },

  methods: {
    handleBook: function handleBook(e) {
      this.$router.push({
        name: 'viewContent'
      });
      if (!e) e = window.event;
      var x = e.currentTarget;
      var book_id = x.id;
      localStorage.setItem('book', book_id);

      //this.$store.dispatch('setBookName', book_id);
    },

    handleViewAll: function handleViewAll() {
      //this.$store.state.ChooseGridView = "novel";
      localStorage.setItem('viewAll', "Novel");
      this.$router.push({
        name: "ViewAll"
      });
    }
  },

  //database
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__firebase_firebaseinit__["a" /* default */].collection('books').where('bookType', '==', "Novel").get().then(function (query) {
      query.forEach(function (doc) {
        var data = {
          id: doc.id,
          bookId: doc.data().bookId,
          bookName: doc.data().bookName,
          bookType: doc.data().bookType,
          datePublished: doc.data().datePublished,
          genre: doc.data().genre,
          language: doc.data().language,
          description: doc.data().description
        };
        _this.books.push(data);
      });

      for (var i = 0; i < _this.$store.state.FixedShow + 1; i++) // push extra so that, it will give more space for view more image
      {
        _this.CurrentContent.push(_this.books[i]);
      }
    });
  }
});

/***/ }),

/***/ 1366:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      showSideMenu: false,
      servicesContent: true,
      categoriesContent: true,
      hideScroll: false,
      windowSize: {
        x: 0,
        y: 0
      },
      resizeLogo: "padding:5px 0px 0 10px;height:50px;",

      changeLogo: 'images/logo.png',
      indexLogo: 0,
      statusLogin: true
    };
  },

  // break point methods
  methods: {
    preventMobileScroll: function preventMobileScroll(event) {
      if (this.hideScroll) {
        event.preventDefault();
        event.stopPropagation();
      } else {
        event.unbind();
      }
    },
    periodicallyChangeLogo: function periodicallyChangeLogo() {
      var logoChange = ["images/logo.png", "images/logo1.png", "images/logo2.png"];
      if (this.indexLogo == 3) this.indexLogo = 0;
    },
    handleScroll: function handleScroll() {
      if (this.hideScroll) {
        // document.documentElement.style.overflow = 'hidden'
        // document.documentElement is the same as using document.querySelector('#root')
      } else {
        document.documentElement.style.overflow = 'auto';
      }
    },
    onResize: function onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
      console.log('height:', this.windowSize.x, ' width:', this.windowSize.y);
      this.changeSize();
    },
    changeSize: function changeSize() {
      if (this.windowSize.x <= 800) {
        console.log('go in');
        this.resizeLogo = "padding:15px 0px 0 0px;height:48px;";
      }
    },
    handleHome: function handleHome() {
      this.$router.push({
        name: "landing"
      });
    },
    handleMyAccount: function handleMyAccount() {
      this.$router.push({
        name: "MyAccount"
      });
    },
    handleSignin: function handleSignin() {
      this.$router.push({
        name: "login"
      });
      localStorage.removeItem('session');
    },
    handleSignout: function handleSignout() {
      localStorage.removeItem('session');
      location.reload();

      this.handleHome();
    },
    checkLogin: function checkLogin() {
      if (localStorage.getItem('session') === null) {
        this.statusLogin = false;
      } else {

        this.statusLogin = true;
      }
    },
    checkVersion: function checkVersion() {
      // var current_version = window.location.origin+'/version.json';
      var configs = {
        headers: { 'Access-Control-Allow-Origin': '*' },
        proxy: { host: '192.168.0.17', port: 8081 }
      };
      var current_version = this.$config.urlBase + '/version.json';
      console.log('website version:', current_version);
      this.$axios.get(current_version, configs).then(function (response) {
        console.log('Version: ', response.data);
        var current_version = response.data;
        // Vue.cordova.on('deviceready', () => {
        //   console.log('LocationFile:',cordova.file.applicationDirectory)
        //   console.log('StorageDirectory:',cordova.file.applicationStorageDirectory)
        //   console.log('DeviceType: ',device.platform)
        // })
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  created: function created() {
    // onFocus = window.scrollTo(0,0)
    this.checkLogin();

    window.scrollTo(0, 0);
  }
});

/***/ }),

/***/ 1367:
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ 1368:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_firebase_firebaseinit__ = __webpack_require__(24);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            id: null,
            name: null,
            email: null,
            pwd: null,
            gender: null,
            location: null,

            logs: []
        };
    },


    methods: {
        handleBook: function handleBook(e) {
            this.$router.push({
                name: 'viewContent'
            });
            if (!e) e = window.event;
            var x = e.currentTarget;
            var book_id = x.id;
            localStorage.setItem('book', book_id);
        }
    },

    //database
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0__components_firebase_firebaseinit__["a" /* default */].collection('users').where('email', '==', localStorage.getItem('session')).get().then(function (query) {
            query.forEach(function (doc) {
                _this.id = doc.id;
                _this.name = doc.data().name;
                _this.email = doc.data().email;
                _this.pwd = doc.data().pwd;
                _this.gender = doc.data().gender;
                _this.location = doc.data().location;
            });
        });

        __WEBPACK_IMPORTED_MODULE_0__components_firebase_firebaseinit__["a" /* default */].collection('history_log').where("email", "==", localStorage.getItem('session')).get().then(function (query) {
            query.forEach(function (doc) {
                var data = {
                    id: doc.id,
                    email: doc.data().email,
                    bookId: doc.data().bookId,
                    bookName: doc.data().bookName,
                    count: doc.data().count
                };
                _this.logs.push(data);
            });
        });

        __WEBPACK_IMPORTED_MODULE_0__components_firebase_firebaseinit__["a" /* default */].collection('reports').where("email", "==", localStorage.getItem('session')).get().then(function (query) {
            query.forEach(function (doc) {
                var data = {
                    id: doc.id,
                    email: doc.data().email,
                    bookId: doc.data().bookId,
                    bookName: doc.data().bookName,
                    count: doc.data().count
                };
                _this.logs.push(data);
            });
        });
    }
});

/***/ }),

/***/ 1369:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_firebase_firebaseinit__ = __webpack_require__(24);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            //MAXVALUE : 50,
            //Limit : 0,
            // The layout mode, possible values are "grid" or "list".
            layout: 'grid',
            books: [],
            type: localStorage.getItem('viewAll')

        };
    },


    methods: {
        handleBookM: function handleBookM(e) {
            //this.$store.state.ChooseContent = this.$store.state.ChooseGridView,
            this.$router.push({
                //name: this.$store.state.ChooseGridView // it depend on category, it will be magazine,newspaper or book
                name: "viewContent"
            });

            if (!e) e = window.event;
            var x = e.currentTarget;
            var book_id = x.id;
            localStorage.setItem('book', book_id);

            //this.$store.dispatch('setBookName', book_id);
        }

        /*NextPage()
        {
            this.Limit = this.Limit + this.MAXVALUE
            console.log(this.Limit)
            
        },
          BackPage()
        {
            this.Limit = this.Limit - this.MAXVALUE
            console.log(this.Limit)
        }*/
    },

    created: function created() {
        var _this = this;

        //console.log(localStorage.getItem('viewAll'))

        __WEBPACK_IMPORTED_MODULE_0__components_firebase_firebaseinit__["a" /* default */].collection('books').orderBy('bookName').get().then(function (query) {
            //.where('bookType','==', this.type)
            query.forEach(function (doc) {
                if (doc.data().bookType == localStorage.getItem('viewAll')) {
                    var data = {
                        id: doc.id,
                        bookId: doc.data().bookId,
                        bookName: doc.data().bookName,
                        bookType: doc.data().bookType,
                        datePublished: doc.data().datePublished,
                        genre: doc.data().genre,
                        language: doc.data().language
                    };
                    _this.books.push(data);
                }
            });
        });
    }
});

/***/ }),

/***/ 1370:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_firebase_firebaseinit__ = __webpack_require__(24);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

__webpack_require__(1416);
__webpack_require__(1418);


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      servicesContent: true,
      categoriesContent: true,
      readMoreActive: false,
      flowPaperContent: false,
      description: true,
      statusLogin: false,
      books: [],
      sameIssue: [],
      NewLog: true,
      currentOpened: 0

    };
  },

  computed: {
    nameState: function nameState() {
      return this.$store.state.idState;
    }
  },
  methods: {
    handleHome: function handleHome() {
      this.$router.push({
        name: "landing"
      });
    },
    handleLogin: function handleLogin() {
      this.$router.push({
        name: "login"
      });
    },
    handleClose: function handleClose() {
      this.bodyContent = true;
      this.flowPaperContent = false;
    },
    handleFlowPaper: function handleFlowPaper() {
      this.CheckLog();
      setTimeout(function () {
        this.bodyContent = false;
        this.flowPaperContent = true;
      }.bind(this), 1000);
      setTimeout(function () {
        window.onbeforeunload = function () {
          console.log('add z-index');
          var wrapper = document.getElementsByClassName('x-wrapper');
          wrapper[0].style.zIndex = "10000";
        };
      }, 5 * 1000);
    },
    CheckLog: function CheckLog() {
      var _this = this;

      //console.log("Done check")
      __WEBPACK_IMPORTED_MODULE_0__components_firebase_firebaseinit__["a" /* default */].collection('history_log').get().then(function (query) {
        query.forEach(function (doc) {
          //.where('bookId','==', books[0].bookId)
          if (doc.data().bookId == _this.books[0].bookId && doc.data().email == localStorage.getItem('session')) {
            _this.currentOpened = doc.data().count;
            //console.log(this.currentOpened)
            _this.UpdateLog();
            _this.NewLog = false;
          }
        });

        if (_this.NewLog) {
          _this.CreateLog();
        }
      });
    },
    CreateLog: function CreateLog() {
      //console.log("Create")
      __WEBPACK_IMPORTED_MODULE_0__components_firebase_firebaseinit__["a" /* default */].collection('history_log').add({
        logId: Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15),
        bookId: this.books[0].bookId,
        bookName: this.books[0].bookName,
        email: localStorage.getItem('session'),
        count: 1

      });
    },
    UpdateLog: function UpdateLog() {
      var _this2 = this;

      //console.log("Update")
      __WEBPACK_IMPORTED_MODULE_0__components_firebase_firebaseinit__["a" /* default */].collection('history_log').where('email', '==', localStorage.getItem('session')).get().then(function (query) {
        query.forEach(function (doc) {
          if (_this2.books[0].bookId == doc.data().bookId) {
            doc.ref.update({
              count: ++_this2.currentOpened
            });
          }
        });
      });
    },
    preventMobileScroll: function preventMobileScroll(event) {
      if (this.hideScroll) {
        event.preventDefault();
        event.stopPropagation();
      } else {
        event.unbind();
      }
    },
    checkLogin: function checkLogin() {
      if (localStorage.getItem('session') === null) {
        this.statusLogin = false;
      } else {
        this.statusLogin = true;
      }
    }
  },

  created: function created() {
    var _this3 = this;

    this.checkLogin();
    //console.log("From local Storage : " + localStorage.getItem('book'))

    __WEBPACK_IMPORTED_MODULE_0__components_firebase_firebaseinit__["a" /* default */].collection('books').where('bookId', '==', localStorage.getItem('book')).get().then(function (query) {
      query.forEach(function (doc) {
        var data = {
          id: doc.id,
          bookId: doc.data().bookId,
          bookName: doc.data().bookName,
          bookType: doc.data().bookType,
          datePublished: doc.data().datePublished,
          genre: doc.data().genre,
          language: doc.data().language,
          description: doc.data().description
        };
        _this3.books.push(data);
      });
    });
  }
});

/***/ }),

/***/ 1371:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_C_Users_user_Desktop_YBR_node_modules_babel_runtime_regenerator__ = __webpack_require__(1377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_C_Users_user_Desktop_YBR_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_C_Users_user_Desktop_YBR_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_C_Users_user_Desktop_YBR_node_modules_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_C_Users_user_Desktop_YBR_node_modules_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_C_Users_user_Desktop_YBR_node_modules_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_firebase_firebaseinit__ = __webpack_require__(24);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      alreadyCorrect: false,
      passwordWrong: false,
      existAlready: false,
      username: "",
      password: ""
    };
  },

  methods: {
    preventMobileScroll: function preventMobileScroll(event) {
      if (this.hideScroll) {
        event.preventDefault();
        event.stopPropagation();
      } else {
        event.unbind();
      }
    },
    onResize: function onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
      console.log('height:', this.windowSize.x, ' width:', this.windowSize.y);
      this.changeSize();
    },
    changeSize: function changeSize() {
      if (this.windowSize.x <= 800) {
        this.resizeLogo = "padding:15px 0px 0 0px;height:48px;";
      }
    },


    getUsernameValidation: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function () {
      var regexUser = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!regexUser.test(this.username)) {
        this.usernameErrorMessage = "That email does not seem right.";
        this.usernameError = true;
        return;
      }
      this.usernameError = false;
      this.usernameErrorMessage = '';
      return true;
    },
    // This is the number of milliseconds we wait for the
    // user to stop typing.
    500),
    getPasswordValidation: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function () {
      var regexPass = /^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})/;
      if (!regexPass.test(this.password)) {
        this.passwordErrorMessage = "Password should be at least 8 characters with alphabets and numerics.";
        this.passwordError = true;
        return;
      }
      this.passwordError = false;
      this.passwordErrorMessage = '';
      return true;
    },
    // This is the number of milliseconds we wait for the
    // user to stop typing.
    500),
    getLoginValidation: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_C_Users_user_Desktop_YBR_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_C_Users_user_Desktop_YBR_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this = this;

        var bodyFormData;
        return __WEBPACK_IMPORTED_MODULE_0_C_Users_user_Desktop_YBR_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                bodyFormData = new FormData();

                bodyFormData.set('page', 'login');
                bodyFormData.set('Email', this.username);
                bodyFormData.set('Password', this.password);
                __WEBPACK_IMPORTED_MODULE_3_axios___default()({
                  method: 'post',
                  url: "https://demolms.sage.com.my/sagelmsv4/mobile/mlogin.do",
                  // url: "https://sir.celex.com.my/sir/mobile/mlogin.do",
                  data: bodyFormData,
                  config: { headers: {
                      "Content-Type": "multipart/form-data" }
                  }
                }).then(function (response) {
                  if (response.data.status == "failed") {
                    if (response.data.errorCode == 10) {
                      _this.$store.commit('setEmail', _this.username);
                      _this.$router.push({
                        name: 'activation'
                      });
                    } else if (response.data.errorCode == 9 || response.data.errorCode == 11) {
                      _this.loginErrorMessage = 'Sorry, we can`t find an account with this email address and password. Please try again.';
                      _this.password = '';
                      _this.passwordError = false;
                      _this.passwordErrorMessage = '';
                      _this.loginErrorBox = false;
                      setTimeout(function () {
                        _this.loginErrorBox = true;
                      }, 1);
                    }
                  } else if (response.data.errorCode == 15) {
                    localStorage.setItem("token", response.data.token);
                    _this.$store.commit('setToken', response.data.token);
                    _this.$store.commit('setResponse', response.data);
                    _this.$router.push({
                      name: 'preference'
                    });
                  } else {
                    localStorage.setItem("token", response.data.token);
                    _this.$store.commit('setToken', response.data.token);
                    _this.$store.commit('setResponse', response.data);
                    _this.$router.push({
                      name: 'landing'
                    });
                  }
                }).catch(function (response) {
                  this.$router.push({
                    name: 'error'
                  });
                  console.log('catch', response);
                });

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getLoginValidation() {
        return _ref.apply(this, arguments);
      }

      return getLoginValidation;
    }(),
    handleSignIn: function handleSignIn() {
      var _this2 = this;

      if (this.username == "" || this.password == "") {
        alert("Fill all information(s)");
      } else {
        __WEBPACK_IMPORTED_MODULE_4__components_firebase_firebaseinit__["a" /* default */].collection('users').get().then(function (query) {
          query.forEach(function (doc) {
            if (_this2.username == doc.data().email) // correct email
              {
                _this2.existAlready = true;
              }
          });

          if (!_this2.existAlready) {
            __WEBPACK_IMPORTED_MODULE_4__components_firebase_firebaseinit__["a" /* default */].collection('users').add({
              email: _this2.username,
              name: _this2.username,
              pwd: _this2.password,
              gender: "",
              location: "YBR_Test"
            });
          }

          alert("Welcome To Serambi Ilmu Rakyat");
          _this2.$router.push({
            name: 'landing'
          });

          localStorage.setItem('session', _this2.username);
        });
      }

      /*if(localStorage.getItem('session')===null)
      {
        alert("Email Are not Available")
      }
        /*
      for(var i = 0 ; i< this.user.length ; i++)
      {
          if(this.username == this.user[i].email && this.password == this.user[i].pwd) // check user
          {
            console.log('username:',this.username,' password:',this.password)
            
            localStorage.setItem('session', (this.user[i].email)); // get email, by real database, take id
            console.log(localStorage.getItem('session'));
              }
      }*/
    },
    handleRecovery: function handleRecovery() {
      this.$router.push({
        name: 'recovery'
      });
    },
    handleRegister: function handleRegister() {
      this.$router.push({
        name: 'register'
      });
    }
  },
  mounted: function mounted() {
    // this.periodicallyChangeLogo()
    this.onResize();
  }
});

/***/ }),

/***/ 1372:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_firebase_firebaseinit__ = __webpack_require__(24);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      email: "",
      fullname: "",
      password: "",
      Cpassword: "",
      gender: "Male",
      location: "YBR_Test", //initial Value

      SameEmail: false

    };
  },


  methods: {
    handleSignUp: function handleSignUp() {
      var _this = this;

      if (this.password != this.Cpassword) {
        alert("Password mismatch");
      } else if (this.username == "" || this.fullname == "" || this.password == "" || this.Cpassword == "") {
        alert("fill all information");
      } else {
        __WEBPACK_IMPORTED_MODULE_0__components_firebase_firebaseinit__["a" /* default */].collection('users').get().then(function (query) {
          query.forEach(function (doc) {
            if (_this.email == doc.data().email) // check if there is same email
              {
                _this.SameEmail = true;
              }
          });

          //after query
          if (!_this.SameEmail) // available email can register
            {
              alert("Done");
              __WEBPACK_IMPORTED_MODULE_0__components_firebase_firebaseinit__["a" /* default */].collection('users').add({
                email: _this.email,
                name: _this.fullname,
                pwd: _this.password,
                gender: _this.gender,
                location: _this.location
              });
              _this.$router.push({
                name: 'login'
              });
            } else // reject the same email
            {
              alert("This email already taken");
              _this.SameEmail = false;
            }
        });
      }
    }
  }

});

/***/ }),

/***/ 1373:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var icons = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlesase make sure you have imported this icon before using it.');
            return false;
          }
          return true;
        }
        console.warn('Invalid prop: prop "name" is required.');
        return false;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      // generate unique id for each icon's SVG element with ID
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=["']?([^"')\s]+)/g, function (match, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}

/***/ }),

/***/ 1374:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_C_Users_user_Desktop_YBR_node_modules_babel_runtime_core_js_object_assign__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_C_Users_user_Desktop_YBR_node_modules_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_C_Users_user_Desktop_YBR_node_modules_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//

window.videojs = __webpack_require__(427);
videojs = videojs.default || videojs;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'video-player',
  props: {
    options: {
      type: Object,
      required: true
    },
    start: {
      type: Number,
      default: function _default() {
        return 0;
      }
    },
    playsinline: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    customEventName: {
      type: String,
      default: function _default() {
        return 'statechanged';
      }
    }
  },
  mounted: function mounted() {
    if (!this.player) {
      this.initialize();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.player) {
      this.dispose();
    }
  },
  methods: {
    initialize: function initialize() {

      // init
      var self = this;
      this.player = null;

      // videojs options
      var videoOptions = __WEBPACK_IMPORTED_MODULE_0_C_Users_user_Desktop_YBR_node_modules_babel_runtime_core_js_object_assign___default()({
        autoplay: false,
        controls: true,
        preload: 'auto',
        fluid: false,
        muted: false,
        width: '100%',
        height: '360',
        language: 'en',
        controlBar: {
          remainingTimeDisplay: false,
          playToggle: {},
          progressControl: {},
          fullscreenToggle: {},
          volumeMenuButton: {
            inline: false,
            vertical: true
          }
        },
        techOrder: ['html5'],
        plugins: {}
      }, this.options);

      // check sources
      /*
      if (!videoOptions.sources || !videoOptions.sources.length) {
        console.warn('Missing required option: "sources".')
        return false
      }
      */

      // ios fullscreen
      var playsinline = this.playsinline;
      if (playsinline) {
        this.$el.children[0].setAttribute('playsinline', playsinline);
        this.$el.children[0].setAttribute('webkit-playsinline', playsinline);
      }

      // emit event
      var emitPlayerState = function emitPlayerState(event, value) {
        if (event) {
          self.$emit(event, self.player);
        }
        if (value) {
          var values = {};
          values[event] = value;
          self.$emit(self.customEventName, values);
        }
      };

      // videoOptions
      // console.log(videoOptions)

      // avoid error "VIDEOJS: ERROR: Unable to find plugin: __ob__"
      if (videoOptions.plugins) {
        delete videoOptions.plugins.__ob__;
      }

      this.player = videojs(this.$el.children[0], videoOptions, function () {

        // player readied
        var _this = this;
        self.$emit('ready', self.player);

        // events
        var events = ['loadeddata', 'canplay', 'canplaythrough', 'play', 'pause', 'waiting', 'playing', 'ended', 'error'];
        for (var i = 0; i < events.length; i++) {
          (function (event) {
            _this.on(event, function () {
              emitPlayerState(event, true);
            });
          })(events[i]);
        }

        this.on('timeupdate', function () {
          emitPlayerState('timeupdate', this.currentTime());
        });
      });
    },
    dispose: function dispose() {
      if (this.player && videojs) {
        if (this.player.techName_ !== 'Flash') {
          this.player.pause && this.player.pause();
        }
        videojs(this.$el.children[0]).dispose();
        if (!this.$el.children.length) {
          var video = document.createElement('video');
          video.className = 'video-js';
          this.$el.appendChild(video);
        }
        this.player = null;
      }
    }
  },
  watch: {
    options: {
      deep: true,
      handler: function handler(options, oldOptions) {
        this.dispose();
        if (options && options.sources && options.sources.length) {
          this.initialize();
        }
      }
    }
  }
});

/***/ }),

/***/ 1414:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1419:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1420:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1421:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1422:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1423:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1424:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1425:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1426:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1427:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1428:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1429:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1430:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1431:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1432:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1433:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1434:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1435:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1436:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1437:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1438:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1439:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1452:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 251,
	"./af.js": 251,
	"./ar": 258,
	"./ar-dz": 252,
	"./ar-dz.js": 252,
	"./ar-kw": 253,
	"./ar-kw.js": 253,
	"./ar-ly": 254,
	"./ar-ly.js": 254,
	"./ar-ma": 255,
	"./ar-ma.js": 255,
	"./ar-sa": 256,
	"./ar-sa.js": 256,
	"./ar-tn": 257,
	"./ar-tn.js": 257,
	"./ar.js": 258,
	"./az": 259,
	"./az.js": 259,
	"./be": 260,
	"./be.js": 260,
	"./bg": 261,
	"./bg.js": 261,
	"./bm": 262,
	"./bm.js": 262,
	"./bn": 263,
	"./bn.js": 263,
	"./bo": 264,
	"./bo.js": 264,
	"./br": 265,
	"./br.js": 265,
	"./bs": 266,
	"./bs.js": 266,
	"./ca": 267,
	"./ca.js": 267,
	"./cs": 268,
	"./cs.js": 268,
	"./cv": 269,
	"./cv.js": 269,
	"./cy": 270,
	"./cy.js": 270,
	"./da": 271,
	"./da.js": 271,
	"./de": 274,
	"./de-at": 272,
	"./de-at.js": 272,
	"./de-ch": 273,
	"./de-ch.js": 273,
	"./de.js": 274,
	"./dv": 275,
	"./dv.js": 275,
	"./el": 276,
	"./el.js": 276,
	"./en-au": 277,
	"./en-au.js": 277,
	"./en-ca": 278,
	"./en-ca.js": 278,
	"./en-gb": 279,
	"./en-gb.js": 279,
	"./en-ie": 280,
	"./en-ie.js": 280,
	"./en-nz": 281,
	"./en-nz.js": 281,
	"./eo": 282,
	"./eo.js": 282,
	"./es": 285,
	"./es-do": 283,
	"./es-do.js": 283,
	"./es-us": 284,
	"./es-us.js": 284,
	"./es.js": 285,
	"./et": 286,
	"./et.js": 286,
	"./eu": 287,
	"./eu.js": 287,
	"./fa": 288,
	"./fa.js": 288,
	"./fi": 289,
	"./fi.js": 289,
	"./fo": 290,
	"./fo.js": 290,
	"./fr": 293,
	"./fr-ca": 291,
	"./fr-ca.js": 291,
	"./fr-ch": 292,
	"./fr-ch.js": 292,
	"./fr.js": 293,
	"./fy": 294,
	"./fy.js": 294,
	"./gd": 295,
	"./gd.js": 295,
	"./gl": 296,
	"./gl.js": 296,
	"./gom-latn": 297,
	"./gom-latn.js": 297,
	"./gu": 298,
	"./gu.js": 298,
	"./he": 299,
	"./he.js": 299,
	"./hi": 300,
	"./hi.js": 300,
	"./hr": 301,
	"./hr.js": 301,
	"./hu": 302,
	"./hu.js": 302,
	"./hy-am": 303,
	"./hy-am.js": 303,
	"./id": 304,
	"./id.js": 304,
	"./is": 305,
	"./is.js": 305,
	"./it": 306,
	"./it.js": 306,
	"./ja": 307,
	"./ja.js": 307,
	"./jv": 308,
	"./jv.js": 308,
	"./ka": 309,
	"./ka.js": 309,
	"./kk": 310,
	"./kk.js": 310,
	"./km": 311,
	"./km.js": 311,
	"./kn": 312,
	"./kn.js": 312,
	"./ko": 313,
	"./ko.js": 313,
	"./ky": 314,
	"./ky.js": 314,
	"./lb": 315,
	"./lb.js": 315,
	"./lo": 316,
	"./lo.js": 316,
	"./lt": 317,
	"./lt.js": 317,
	"./lv": 318,
	"./lv.js": 318,
	"./me": 319,
	"./me.js": 319,
	"./mi": 320,
	"./mi.js": 320,
	"./mk": 321,
	"./mk.js": 321,
	"./ml": 322,
	"./ml.js": 322,
	"./mr": 323,
	"./mr.js": 323,
	"./ms": 325,
	"./ms-my": 324,
	"./ms-my.js": 324,
	"./ms.js": 325,
	"./my": 326,
	"./my.js": 326,
	"./nb": 327,
	"./nb.js": 327,
	"./ne": 328,
	"./ne.js": 328,
	"./nl": 330,
	"./nl-be": 329,
	"./nl-be.js": 329,
	"./nl.js": 330,
	"./nn": 331,
	"./nn.js": 331,
	"./pa-in": 332,
	"./pa-in.js": 332,
	"./pl": 333,
	"./pl.js": 333,
	"./pt": 335,
	"./pt-br": 334,
	"./pt-br.js": 334,
	"./pt.js": 335,
	"./ro": 336,
	"./ro.js": 336,
	"./ru": 337,
	"./ru.js": 337,
	"./sd": 338,
	"./sd.js": 338,
	"./se": 339,
	"./se.js": 339,
	"./si": 340,
	"./si.js": 340,
	"./sk": 341,
	"./sk.js": 341,
	"./sl": 342,
	"./sl.js": 342,
	"./sq": 343,
	"./sq.js": 343,
	"./sr": 345,
	"./sr-cyrl": 344,
	"./sr-cyrl.js": 344,
	"./sr.js": 345,
	"./ss": 346,
	"./ss.js": 346,
	"./sv": 347,
	"./sv.js": 347,
	"./sw": 348,
	"./sw.js": 348,
	"./ta": 349,
	"./ta.js": 349,
	"./te": 350,
	"./te.js": 350,
	"./tet": 351,
	"./tet.js": 351,
	"./th": 352,
	"./th.js": 352,
	"./tl-ph": 353,
	"./tl-ph.js": 353,
	"./tlh": 354,
	"./tlh.js": 354,
	"./tr": 355,
	"./tr.js": 355,
	"./tzl": 356,
	"./tzl.js": 356,
	"./tzm": 358,
	"./tzm-latn": 357,
	"./tzm-latn.js": 357,
	"./tzm.js": 358,
	"./uk": 359,
	"./uk.js": 359,
	"./ur": 360,
	"./ur.js": 360,
	"./uz": 362,
	"./uz-latn": 361,
	"./uz-latn.js": 361,
	"./uz.js": 362,
	"./vi": 363,
	"./vi.js": 363,
	"./x-pseudo": 364,
	"./x-pseudo.js": 364,
	"./yo": 365,
	"./yo.js": 365,
	"./zh-cn": 366,
	"./zh-cn.js": 366,
	"./zh-hk": 367,
	"./zh-hk.js": 367,
	"./zh-tw": 368,
	"./zh-tw.js": 368
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1452;

/***/ }),

/***/ 1670:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1432)

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1357),
  /* template */
  __webpack_require__(1697),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1671:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1438)

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1358),
  /* template */
  __webpack_require__(1703),
  /* scopeId */
  "data-v-cc32f8c0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1672:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1437)

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1359),
  /* template */
  __webpack_require__(1702),
  /* scopeId */
  "data-v-9d328f60",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1673:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1420)

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1360),
  /* template */
  __webpack_require__(1687),
  /* scopeId */
  "data-v-04a854ee",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1674:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1423)

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1361),
  /* template */
  __webpack_require__(1689),
  /* scopeId */
  "data-v-0b247c07",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1675:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1425)

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1362),
  /* template */
  __webpack_require__(1691),
  /* scopeId */
  "data-v-1e9e49be",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1676:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1427)

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1363),
  /* template */
  __webpack_require__(1693),
  /* scopeId */
  "data-v-37752ae8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1677:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1424)

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1364),
  /* template */
  __webpack_require__(1690),
  /* scopeId */
  "data-v-10e0bac6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1678:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1426)

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1365),
  /* template */
  __webpack_require__(1692),
  /* scopeId */
  "data-v-3506e2e0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1679:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1439)

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1366),
  /* template */
  __webpack_require__(1704),
  /* scopeId */
  "data-v-f801ad14",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1680:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1431)

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1367),
  /* template */
  __webpack_require__(1696),
  /* scopeId */
  "data-v-603c689c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1681:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1433)
__webpack_require__(1434)

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1368),
  /* template */
  __webpack_require__(1698),
  /* scopeId */
  "data-v-6af8a390",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1682:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1435)

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1369),
  /* template */
  __webpack_require__(1699),
  /* scopeId */
  "data-v-6c75e5ab",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1683:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1428)

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1370),
  /* template */
  __webpack_require__(1694),
  /* scopeId */
  "data-v-5257a8fa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1684:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1421)
__webpack_require__(1422)

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1371),
  /* template */
  __webpack_require__(1688),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1685:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1429)
__webpack_require__(1430)

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1372),
  /* template */
  __webpack_require__(1695),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1686:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1374),
  /* template */
  __webpack_require__(1701),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1687:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tren-crs"
    }
  }, [_c('h3', [_vm._v("Agama")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "Right"
    },
    on: {
      "click": function($event) {
        _vm.handleViewAll()
      }
    }
  }, [_c('a', [_vm._v("View All...")])]), _vm._v(" "), _c('div', {
    staticClass: "crs-swiper-container"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.courseSwiper
    }
  }, _vm._l((_vm.CurrentContent), function(m, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "card card-1",
      attrs: {
        "id": "course-swiper"
      }
    }, [(index < _vm.$store.state.FixedShow) ? _c('div', [_c('img', {
      staticClass: "swiper-lazy pointer",
      attrs: {
        "src": _vm.$store.state.urlLink + m.bookId + '.png',
        "alt": m.bookName,
        "kappa": m.BookName,
        "id": m.bookId
      },
      on: {
        "click": _vm.handleBook
      }
    })]) : _c('div', [_c('img', {
      staticClass: "swiper-lazy pointer",
      attrs: {
        "id": "ViewMore",
        "src": "images/View More(N).png"
      },
      on: {
        "click": function($event) {
          _vm.handleViewAll()
        }
      }
    })])])
  }))], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1688:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('App-SideMenu'), _vm._v(" "), _c('main', {
    staticClass: "cd-main-content"
  }, [_c('div', {
    staticClass: "landing-main-content"
  }, [_c('div', {
    staticClass: "book-bg"
  }, [_c('div', {
    staticClass: "pl-bg-gradientz"
  }, [_c('div', {
    staticClass: "wrapper-square"
  }, [_c('form', {
    staticClass: "login-form-wrapper"
  }, [_c('div', {
    staticClass: "login-form-content"
  }, [_c('h1', [_vm._v("Sign In")]), _vm._v(" "), _c('div', {
    staticClass: "login-input-containers"
  }, [_c('h3', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("EMAIL")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "type": "texts",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "red fs-12 block"
  }, [_vm._v(_vm._s(_vm.usernameErrorMessage))])]), _vm._v(" "), _c('div', {
    staticClass: "login-input-containers"
  }, [_c('h3', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("PASSWORD")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "red fs-12 block"
  }, [_vm._v(_vm._s(_vm.passwordErrorMessage))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "pointer",
    attrs: {
      "id": "login-register-btn"
    },
    on: {
      "click": function($event) {
        _vm.handleSignIn()
      }
    }
  }, [_vm._v("Sign In")]), _vm._v(" "), _vm._m(0, false, false)])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login-signup-link"
    }
  }, [_c('h3', [_vm._v("Use Serambi Ilmu Rakyat Account ")])])
}]}

/***/ }),

/***/ 1689:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tren-crs"
    }
  }, [_c('h3', [_vm._v("Bukan Fiksyen")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "Right"
    },
    on: {
      "click": function($event) {
        _vm.handleViewAll()
      }
    }
  }, [_c('a', [_vm._v("View All...")])]), _vm._v(" "), _c('div', {
    staticClass: "crs-swiper-container"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.courseSwiper
    }
  }, _vm._l((_vm.CurrentContent), function(m, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "card card-1",
      attrs: {
        "id": "course-swiper"
      }
    }, [(index < _vm.$store.state.FixedShow) ? _c('div', [_c('img', {
      staticClass: "swiper-lazy pointer",
      attrs: {
        "src": _vm.$store.state.urlLink + m.bookId + '.png',
        "alt": m.bookName,
        "kappa": m.BookName,
        "id": m.bookId
      },
      on: {
        "click": _vm.handleBook
      }
    })]) : _c('div', [_c('img', {
      staticClass: "swiper-lazy pointer",
      attrs: {
        "id": "ViewMore",
        "src": "images/View More(N).png"
      },
      on: {
        "click": function($event) {
          _vm.handleViewAll()
        }
      }
    })])])
  }))], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1690:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tren-crs"
    }
  }, [_c('h3', [_vm._v("Magazines")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "Right"
    },
    on: {
      "click": function($event) {
        _vm.handleViewAll()
      }
    }
  }, [_c('a', [_vm._v("View All...")])]), _vm._v(" "), _c('div', {
    staticClass: "crs-swiper-container"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.courseSwiper
    }
  }, _vm._l((_vm.CurrentContent), function(m, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "card card-1",
      attrs: {
        "id": "course-swiper"
      }
    }, [(index < _vm.$store.state.FixedShow) ? _c('div', [_c('img', {
      staticClass: "swiper-lazy pointer",
      attrs: {
        "src": _vm.$store.state.urlLink + m.bookId + '.png',
        "alt": m.BookName,
        "kappa": m.BookName,
        "id": m.bookId
      },
      on: {
        "click": _vm.handleBook
      }
    })]) : _c('div', [_c('img', {
      staticClass: "swiper-lazy pointer",
      attrs: {
        "id": "ViewMore",
        "src": "images/View More(M).png"
      },
      on: {
        "click": function($event) {
          _vm.handleViewAll()
        }
      }
    })])])
  }))], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1691:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tren-crs"
    }
  }, [_c('h3', [_vm._v("Kanak-Kanak")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "Right"
    },
    on: {
      "click": function($event) {
        _vm.handleViewAll()
      }
    }
  }, [_c('a', [_vm._v("View All...")])]), _vm._v(" "), _c('div', {
    staticClass: "crs-swiper-container"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.courseSwiper
    }
  }, _vm._l((_vm.CurrentContent), function(m, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "card card-1",
      attrs: {
        "id": "course-swiper"
      }
    }, [(index < _vm.$store.state.FixedShow) ? _c('div', [_c('img', {
      staticClass: "swiper-lazy pointer",
      attrs: {
        "src": _vm.$store.state.urlLink + m.bookId + '.png',
        "alt": m.bookName,
        "kappa": m.BookName,
        "id": m.bookId
      },
      on: {
        "click": _vm.handleBook
      }
    })]) : _c('div', [_c('img', {
      staticClass: "swiper-lazy pointer",
      attrs: {
        "id": "ViewMore",
        "src": "images/View More(N).png"
      },
      on: {
        "click": function($event) {
          _vm.handleViewAll()
        }
      }
    })])])
  }))], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1692:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tren-crs"
    }
  }, [_c('h3', [_vm._v("Novels")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "Right"
    },
    on: {
      "click": function($event) {
        _vm.handleViewAll()
      }
    }
  }, [_c('a', [_vm._v("View All...")])]), _vm._v(" "), _c('div', {
    staticClass: "crs-swiper-container"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.courseSwiper
    }
  }, _vm._l((_vm.CurrentContent), function(m, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "card card-1",
      attrs: {
        "id": "course-swiper"
      }
    }, [(index < _vm.$store.state.FixedShow) ? _c('div', [_c('img', {
      staticClass: "swiper-lazy pointer",
      attrs: {
        "src": _vm.$store.state.urlLink + m.bookId + '.png',
        "alt": m.BookName,
        "kappa": m.BookName,
        "id": m.bookId
      },
      on: {
        "click": _vm.handleBook
      }
    })]) : _c('div', [_c('img', {
      staticClass: "swiper-lazy pointer",
      attrs: {
        "id": "ViewMore",
        "src": "images/View More(N).png"
      },
      on: {
        "click": function($event) {
          _vm.handleViewAll()
        }
      }
    })])])
  }))], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1693:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tren-crs"
    }
  }, [_c('h3', [_vm._v("Children")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "Right"
    },
    on: {
      "click": function($event) {
        _vm.handleViewAll()
      }
    }
  }, [_c('a', [_vm._v("View All...")])]), _vm._v(" "), _c('div', {
    staticClass: "crs-swiper-container"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.courseSwiper
    }
  }, _vm._l((_vm.CurrentContent), function(m, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "card card-1",
      attrs: {
        "id": "course-swiper"
      }
    }, [(index < _vm.$store.state.FixedShow) ? _c('div', [_c('img', {
      staticClass: "swiper-lazy pointer",
      attrs: {
        "src": _vm.$store.state.urlLink + m.bookId + '.png',
        "alt": m.BookName,
        "kappa": m.BookName,
        "id": m.bookId
      },
      on: {
        "click": _vm.handleBook
      }
    })]) : _c('div', [_c('img', {
      staticClass: "swiper-lazy pointer",
      attrs: {
        "id": "ViewMore",
        "src": "images/View More(C).png"
      },
      on: {
        "click": function($event) {
          _vm.handleViewAll()
        }
      }
    })])])
  }))], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1694:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.flowPaperContent) ? _c('div', [_c('div', {
    staticClass: "x-wrapper x-absolute",
    on: {
      "click": function($event) {
        _vm.handleClose()
      }
    }
  }, [_c('icon', {
    staticClass: "close-icon pointer",
    attrs: {
      "name": "close",
      "scale": "1.5"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.books), function(myBook) {
    return _c('div', {
      key: myBook.id,
      staticClass: "responsive-iframe"
    }, [_c('iframe', {
      attrs: {
        "src": _vm.$store.state.urlLink + myBook.bookId + '/',
        "frameborder": "0",
        "allowfullscreen": ""
      }
    })])
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.flowPaperContent) ? _c('div', [_c('App-SideMenu'), _vm._v(" "), _c('main', {
    staticClass: "cd-main-content landing-color"
  }, [_c('div', {
    staticClass: "bk-content"
  }, _vm._l((_vm.books), function(myBook) {
    return _c('div', {
      key: myBook.id,
      staticClass: "book-pic-bg"
    }, [_c('a', {
      attrs: {
        "id": "book-pic-wrapper"
      }
    }, [_c('img', {
      staticClass: "pic-element",
      attrs: {
        "src": _vm.$store.state.urlLink + myBook.bookId + '.png'
      }
    })])])
  })), _vm._v(" "), _c('div', {
    staticClass: "book-pic-desc"
  }, [_c('div', {
    staticClass: "book-pic-details"
  }, [_c('h5', {
    attrs: {
      "id": "book-title-font"
    }
  }, _vm._l((_vm.books), function(myBook) {
    return _c('strong', {
      key: myBook.id
    }, [_vm._v("\n                  " + _vm._s(myBook.bookName) + "\n                ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "bk-pic-nav"
  }, _vm._l((_vm.books), function(myBook) {
    return _c('ul', {
      key: myBook.id,
      staticClass: "bk-pic-nav-info"
    }, [_c('li', {
      staticClass: "bk-pic-nav-item"
    }, [_vm._v(_vm._s(myBook.datePublished))]), _vm._v(" "), _c('li', {
      staticClass: "bk-pic-nav-item"
    }, [_vm._v("Language : " + _vm._s(myBook.language))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "bk-btn-desc"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.statusLogin),
      expression: "!statusLogin"
    }],
    staticClass: "bk-button-nav"
  }, [_c('button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple",
      value: ('rgba(255, 255, 255, 0.2)'),
      expression: "'rgba(255, 255, 255, 0.2)'"
    }],
    attrs: {
      "id": "bk-btn-subscribe"
    },
    on: {
      "click": function($event) {
        _vm.handleLogin()
      }
    }
  }, [_vm._v("LOGIN TO READ")]), _vm._v(" "), _c('h3')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.statusLogin),
      expression: "statusLogin"
    }],
    staticClass: "bk-button-nav"
  }, [_c('button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple",
      value: ('rgba(255, 255, 255, 0.2)'),
      expression: "'rgba(255, 255, 255, 0.2)'"
    }],
    attrs: {
      "id": "bk-btn-all-content"
    },
    on: {
      "click": function($event) {
        _vm.handleFlowPaper()
      }
    }
  }, [_vm._v("READ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.description),
      expression: "description"
    }],
    attrs: {
      "id": "bk-book-text-wrapper"
    }
  }, [_c('div', {
    staticClass: "bk-pic-text-detail"
  }, [_c('div', {
    staticClass: "truncate truncate1",
    class: {
      toggleReadMore: _vm.readMoreActive
    },
    staticStyle: {
      "color": "#fff"
    }
  }, _vm._l((_vm.books), function(myBook) {
    return _c('p', {
      key: myBook.id
    }, [_vm._v(" \n                " + _vm._s(myBook.description) + "\n              ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "white-divider"
  }, [_c('span', {
    staticClass: "divider-ball",
    class: {
      flipBall: _vm.readMoreActive
    },
    on: {
      "click": function($event) {
        _vm.readMoreActive = !_vm.readMoreActive
      }
    }
  }, [_c('span', {
    staticClass: "divider-icon"
  })])])])])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 1695:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('App-SideMenu'), _vm._v(" "), _c('main', {
    staticClass: "cd-main-content landing-color"
  }, [_c('div', {
    staticClass: "landing-main-content"
  }, [_c('div', {
    staticClass: "book-bg"
  }, [_c('div', {}, [_c('div', {
    staticClass: "wrapper-square"
  }, [_c('form', {
    staticClass: "login-form-wrapper"
  }, [_c('div', {
    staticClass: "login-form-content"
  }, [_c('h1', [_vm._v("Register New Account")]), _vm._v(" "), _c('div', {
    staticClass: "login-input-containers"
  }, [_c('h3', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("EMAIL")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "Email",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "login-input-containers"
  }, [_c('h3', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("FULL NAME")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fullname),
      expression: "fullname"
    }],
    attrs: {
      "type": "texts",
      "placeholder": "Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.fullname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fullname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "login-input-containers"
  }, [_c('h3', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("PASSWORD")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "login-input-containers"
  }, [_c('h3', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("RECONFIRM PASSWORD")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Cpassword),
      expression: "Cpassword"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.Cpassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Cpassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "login-input-containers"
  }, [_c('h3', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("Gender")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    attrs: {
      "type": "radio",
      "name": "Gender",
      "value": "Male",
      "required": "",
      "checked": ""
    },
    domProps: {
      "checked": _vm._q(_vm.gender, "Male")
    },
    on: {
      "change": function($event) {
        _vm.gender = "Male"
      }
    }
  }), _vm._v(" Male\n                  "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    attrs: {
      "type": "radio",
      "name": "Gender",
      "value": "Female",
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.gender, "Female")
    },
    on: {
      "change": function($event) {
        _vm.gender = "Female"
      }
    }
  }), _vm._v(" Female\n                  "), _c('br')]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "pointer",
    attrs: {
      "id": "login-register-btn"
    },
    on: {
      "click": function($event) {
        _vm.handleSignUp()
      }
    }
  }, [_vm._v("Sign Up")]), _vm._v(" "), _vm._m(0, false, false)])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login-signup-link"
    }
  }, [_c('h3', [_vm._v("By register this account, you already accepted our terms and agreement. \n                ")])])
}]}

/***/ }),

/***/ 1696:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('App-SideMenu'), _vm._v(" "), _c('main', {
    staticClass: "cd-main-content"
  }, [_c('div', {
    staticClass: "landing-main-content"
  }, [_c('App-No1Majalah'), _vm._v(" "), _c('App-No2Fiksyen'), _vm._v(" "), _c('App-No3Agama'), _vm._v(" "), _c('App-No4BukanFiksyen'), _vm._v(" "), _c('App-No5Kanak'), _vm._v(" "), _vm._m(0, false, false)], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "mid-banner"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://elibrary.yayasanbankrakyat.com.my"
    }
  }, [_c('img', {
    attrs: {
      "id": "mid-banner-img",
      "src": "images/SIR Banner.png"
    }
  })])])
}]}

/***/ }),

/***/ 1697:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1698:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('App-SideMenu'), _vm._v(" "), _c('main', {
    staticClass: "cd-main-content"
  }, [_c('div', {
    staticClass: "landing-main-content"
  }, [_c('div', {
    staticClass: "book-bg"
  }, [_c('div', {
    staticClass: "wrapper-square"
  }, [_c('div', {
    staticClass: "login-form-wrapper"
  }, [_c('div', {
    staticClass: "login-form-content"
  }, [_c('h1', [_vm._v("My Account")]), _vm._v(" "), _c('div', {
    staticClass: "login-input-containers"
  }, [_c('h3', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("EMAIL : ")]), _vm._v(" "), _c('h4', [_vm._v(" " + _vm._s(this.email) + " ")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('h2', [_vm._v("My Read History")]), _vm._v(" "), _c('table', {
    attrs: {
      "id": "log"
    }
  }, [_vm._m(0, false, false), _vm._v(" "), _vm._l((_vm.logs), function(log) {
    return _c('tr', {
      key: log.id
    }, [_c('td', [_c('img', {
      attrs: {
        "src": _vm.$store.state.urlLink + log.bookId + '.png'
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.bookName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.count))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "button",
      staticStyle: {
        "vertical-align": "middle"
      },
      attrs: {
        "id": log.bookId
      },
      on: {
        "click": _vm.handleBook
      }
    }, [_c('span', [_vm._v("Read")])])])])
  })], 2)])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Book")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Opened")]), _vm._v(" "), _c('th')])
}]}

/***/ }),

/***/ 1699:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('App-SideMenu'), _vm._v(" "), _c('main', {
    staticClass: "cd-main-content landing-color"
  }, [_c('ul', {
    staticClass: "grid"
  }, [_c('h1', [_vm._v("HERE ALL BOOKS LIST")]), _vm._v(" "), _vm._l((_vm.books), function(m, index) {
    return _c('li', {
      key: index
    }, [_c('img', {
      staticClass: "swiper-lazy pointer",
      attrs: {
        "kappa": m.bookName,
        "id": m.bookId,
        "src": _vm.$store.state.urlLink + m.bookId + '.png'
      },
      on: {
        "click": _vm.handleBookM
      }
    })])
  })], 2)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1700:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.klass,
    style: (_vm.style),
    attrs: {
      "version": "1.1",
      "role": _vm.label ? 'img' : 'presentation',
      "aria-label": _vm.label,
      "x": _vm.x,
      "y": _vm.y,
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.box
    }
  }, [_vm._t("default", [(_vm.icon && _vm.icon.paths) ? _vm._l((_vm.icon.paths), function(path, i) {
    return _c('path', _vm._b({
      key: ("path-" + i)
    }, 'path', path, false))
  }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.polygons) ? _vm._l((_vm.icon.polygons), function(polygon, i) {
    return _c('polygon', _vm._b({
      key: ("polygon-" + i)
    }, 'polygon', polygon, false))
  }) : _vm._e(), _vm._v("\b\n    "), (_vm.icon && _vm.icon.raw) ? [_c('g', {
    domProps: {
      "innerHTML": _vm._s(_vm.raw)
    }
  })] : _vm._e()])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1701:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-player"
  }, [_c('video', {
    staticClass: "video-js"
  })])
}]}

/***/ }),

/***/ 1702:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tren-crs"
    }
  }, [_c('h3', [_vm._v("Fiksyen")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "Right"
    },
    on: {
      "click": function($event) {
        _vm.handleViewAll()
      }
    }
  }, [_c('a', [_vm._v("View All...")])]), _vm._v(" "), _c('div', {
    staticClass: "crs-swiper-container"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.courseSwiper
    }
  }, _vm._l((_vm.CurrentContent), function(m, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "card card-1",
      attrs: {
        "id": "course-swiper"
      }
    }, [(index < _vm.$store.state.FixedShow) ? _c('div', [_c('img', {
      staticClass: "swiper-lazy pointer",
      attrs: {
        "src": _vm.$store.state.urlLink + m.bookId + '.png',
        "alt": m.bookName,
        "kappa": m.BookName,
        "id": m.bookId
      },
      on: {
        "click": _vm.handleBook
      }
    })]) : _c('div', [_c('img', {
      staticClass: "swiper-lazy pointer",
      attrs: {
        "id": "ViewMore",
        "src": "images/View More(N).png"
      },
      on: {
        "click": function($event) {
          _vm.handleViewAll()
        }
      }
    })])])
  }))], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1703:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tren-crs"
    }
  }, [_c('h3', [_vm._v("Majalah")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "Right"
    },
    on: {
      "click": function($event) {
        _vm.handleViewAll()
      }
    }
  }, [_c('a', [_vm._v("View All...")])]), _vm._v(" "), _c('div', {
    staticClass: "crs-swiper-container"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.courseSwiper
    }
  }, _vm._l((_vm.CurrentContent), function(m, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "card card-1",
      attrs: {
        "id": "course-swiper"
      }
    }, [(index < _vm.$store.state.FixedShow) ? _c('div', [_c('img', {
      staticClass: "swiper-lazy pointer",
      attrs: {
        "src": _vm.$store.state.urlLink + m.bookId + '.png',
        "alt": m.bookName,
        "kappa": m.BookName,
        "id": m.bookId
      },
      on: {
        "click": _vm.handleBook
      }
    })]) : _c('div', [_c('img', {
      staticClass: "swiper-lazy pointer",
      attrs: {
        "id": "ViewMore",
        "src": "images/View More(M).png"
      },
      on: {
        "click": function($event) {
          _vm.handleViewAll()
        }
      }
    })])])
  }))], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1704:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showSideMenu) ? _c('aside', {
    staticClass: "sidebar animated slideInLeft",
    attrs: {
      "id": "side-menu"
    }
  }, [_c('div', {
    staticClass: "nan",
    attrs: {
      "id": "leftside-navigation"
    }
  }, [_c('ul', {
    staticClass: "nano-content"
  }, [_c('li', {
    staticClass: "sub-menu active"
  }, [_c('a', {
    staticClass: "pointer",
    on: {
      "click": _vm.handleHome
    }
  }, [_c('icon', {
    staticClass: "fa-position",
    attrs: {
      "name": "home"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Home")])], 1)]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.statusLogin),
      expression: "statusLogin"
    }],
    on: {
      "click": _vm.handleMyAccount
    }
  }, [_c('a', {
    staticClass: "pointer"
  }, [_c('icon', {
    staticClass: "fa-position",
    attrs: {
      "name": "user-circle-o"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Account")])], 1)]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.statusLogin),
      expression: "statusLogin"
    }]
  }, [_c('a', {
    staticClass: "pointer",
    on: {
      "click": _vm.handleSignout
    }
  }, [_c('icon', {
    staticClass: "fa-position",
    attrs: {
      "name": "sign-out"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Logout")])], 1)]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.statusLogin),
      expression: "!statusLogin"
    }]
  }, [_c('a', {
    staticClass: "pointer",
    on: {
      "click": _vm.handleSignin
    }
  }, [_c('icon', {
    staticClass: "fa-position",
    attrs: {
      "name": "sign-in"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Login")])], 1)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "resize",
      rawName: "v-resize",
      value: (_vm.onResize),
      expression: "onResize"
    }],
    attrs: {
      "id": "landing-body"
    },
    on: {
      "touchmove": _vm.preventMobileScroll
    }
  }, [_c('header', {
    staticStyle: {
      "background-color": "white"
    },
    attrs: {
      "id": "cd-header align-right"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "images/SIR (Small).png",
      "alt": "Homepage"
    },
    on: {
      "click": _vm.handleHome
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "pointer",
    attrs: {
      "id": "cd-menu-trigger"
    },
    on: {
      "click": function($event) {
        _vm.showSideMenu = !_vm.showSideMenu, _vm.hideScroll = !_vm.hideScroll, _vm.handleScroll()
      }
    }
  }, [_c('span', {
    staticClass: "cd-menu-text",
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Menu")]), _vm._v(" "), _c('span', {
    staticClass: "cd-menu-icon",
    staticStyle: {
      "background-color": "black"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0",
      "display": "inline-block",
      "height": "70px",
      "float": "right",
      "padding": "0"
    }
  }, [_c('form', {
    attrs: {
      "action": "",
      "autocomplete": "on"
    }
  }, [_c('input', {
    staticStyle: {
      "background-color": "white",
      "text-fill-color": "black"
    },
    attrs: {
      "id": "search",
      "name": "search",
      "type": "text",
      "color": "black",
      "placeholder": "Search..."
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "id": "search_submit",
      "value": "SearchStuff",
      "type": "submit"
    }
  }), _vm._v(" "), _c('icon', {
    staticClass: "search-position",
    staticStyle: {
      "position": "absolute",
      "top": "20px",
      "right": "25px",
      "padding": "5px 5px 5xp 5px",
      "color": "black"
    },
    attrs: {
      "name": "search",
      "scale": "1.4"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    class: {
      paneloverlay: _vm.showSideMenu
    },
    on: {
      "click": function($event) {
        _vm.showSideMenu = !_vm.showSideMenu, _vm.hideScroll = !_vm.hideScroll, _vm.handleScroll()
      }
    }
  })])])])
},staticRenderFns: []}

/***/ }),

/***/ 1717:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1718:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1719:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/VideoJS.46ac6629.eot";

/***/ }),

/***/ 230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  "base": "https://myneighby.herokuapp.com/",
  "login": "api/v2/login",
  "modules": "api/v2/features",
  "posts": "api/v2/communities",
  "signUp": "api/v2/signup",
  "users": "api/v2/users"
});

/***/ }),

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(568);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
    FixedShow: 10,
    urlLink: "http://sir.celex.com.my/storage/viewer/", // this is for online ver
    //urlLink : "/images/viewer/", // hybrid ver content on laptop but data on firebase

    idState: { name: "" },

    //ChooseGridView : "", // use for viewing content on ViewAll.vue
    //ChooseContent : '', // use for viewing content on ViewContent.vue

    deviceType: { platform: "", version: "" }
    // currently there are 3 localstorage been use inside code
    // 1. localStorage.getItem('session') -> use for keep user login info
    // 2. localStorage.getItem('book') -> hold last book id that been click 
    // 3. localStorage.getItem('viewAll') -> hold type of magazine that need to be view
};

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: state,
    mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */]
});
/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 24:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(1444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_firestore__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase_firestore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebaseConfig__ = __webpack_require__(563);



var firebaseApp = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp(__WEBPACK_IMPORTED_MODULE_2__firebaseConfig__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (firebaseApp.firestore());

/***/ }),

/***/ 430:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return app; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_C_Users_user_Desktop_YBR_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_C_Users_user_Desktop_YBR_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_C_Users_user_Desktop_YBR_node_modules_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__ = __webpack_require__(1713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_ripple_directive__ = __webpack_require__(1708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_float_label__ = __webpack_require__(1669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_float_label___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_float_label__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_cordova__ = __webpack_require__(1668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_cordova___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_cordova__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_config__ = __webpack_require__(1667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_moment__ = __webpack_require__(1705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_on_click_outside__ = __webpack_require__(1707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_on_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_on_click_outside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_App_vue__ = __webpack_require__(1670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__router__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__static_scss_app_scss__ = __webpack_require__(1419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__static_scss_app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__static_scss_app_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__static_css_animated_css__ = __webpack_require__(1414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__static_css_animated_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__static_css_animated_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_awesome_swiper__ = __webpack_require__(1666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_swiper_dist_css_swiper_css__ = __webpack_require__(1415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_swiper_dist_css_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_nav_tabs__ = __webpack_require__(1706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_nav_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_nav_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_nav_tabs_themes_vue_tabs_css__ = __webpack_require__(1417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_nav_tabs_themes_vue_tabs_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_nav_tabs_themes_vue_tabs_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_video_player__ = __webpack_require__(1712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_video_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_video_player__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_awesome_components_Icon__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_awesome_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_awesome_icons__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_axios__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_axios__);
/* unused harmony reexport router */
/* unused harmony reexport store */












// import * as bootstrap from './static/css/bootstrap.css'




// import ReadMore from 'vue-read-more'
//import Tab from 'vue-swipe-tab'


//import {Tabs, Tab} from 'vue-tabs-component';
//Vue.component('tabs', Tabs);
//Vue.component('tab', Tab);
//import VueParticles from 'vue-particles'





var VueTouch = __webpack_require__(1711);

window.$ = window.jQuery = __webpack_require__(1451);

var configs = {
    pdfLocation: '',
    urlBase: 'http://sir.celex.com.my',
    version: '2.0.7'
};

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.silent = true;
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.devtools = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$axios = __WEBPACK_IMPORTED_MODULE_21_axios___default.a;

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_config___default.a, configs);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(VueTouch, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_cordova___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_float_label___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_moment___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].directive('ripple', __WEBPACK_IMPORTED_MODULE_3_vue_ripple_directive__["a" /* default */]);
// Vue.use(bootstrap)
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12__static_scss_app_scss__);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_13__static_css_animated_css__);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].directive('on-click-outside', __WEBPACK_IMPORTED_MODULE_8_vue_on_click_outside__["directive"]);
// Vue.use(VueFire);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_14_vue_awesome_swiper___default.a);
// Vue.use(ReadMore)
//Vue.use(Tab)
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_16_vue_nav_tabs___default.a);
//Vue.use(VueParticles)
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_18_vue_video_player___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('icon', __WEBPACK_IMPORTED_MODULE_19_vue_awesome_components_Icon___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].cordova.on('deviceready', function () {
    // console.log('LocationFile:',cordova.file.applicationDirectory)
    // console.log('StorageDirectory:',cordova.file.applicationStorageDirectory)
    console.log('DeviceType: ', device.platform);
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */]);
var app = new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_C_Users_user_Desktop_YBR_node_modules_babel_runtime_helpers_extends___default()({
    router: __WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */]
}, __WEBPACK_IMPORTED_MODULE_9__components_App_vue___default.a));



/***/ }),

/***/ 431:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_promise_polyfill__);


window.Promise = window.Promise || __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default.a;

/***/ }),

/***/ 432:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime__ = __webpack_require__(1453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime__);


__WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default.a.install({
  // When an update is ready, tell ServiceWorker to take control immediately:
  onUpdateReady: function onUpdateReady() {
    __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default.a.applyUpdate();
  },


  // Reload to get the new version:
  onUpdated: function onUpdated() {
    location.reload();
  }
});

/***/ }),

/***/ 563:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    apiKey: "AIzaSyDhDC_UzMZ5qjsDvnC_hQWGx1Px-Y4s03o",
    authDomain: "vuefs-prod-418c8.firebaseapp.com",
    databaseURL: "https://vuefs-prod-418c8.firebaseio.com",
    projectId: "vuefs-prod-418c8",
    storageBucket: "vuefs-prod-418c8.appspot.com",
    messagingSenderId: "521365352888"
});

/***/ }),

/***/ 564:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__promise_polyfill__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(430);



var pwa = __webpack_require__(432);
// Enable progressive web app support (with offline-plugin)
if (true) {
  pwa;
}
__WEBPACK_IMPORTED_MODULE_1__app__["a" /* app */].$mount('#app');

/***/ }),

/***/ 565:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_login__ = __webpack_require__(1684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_register__ = __webpack_require__(1685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_register___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_register__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_sidemenu_SideMenu__ = __webpack_require__(1679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_sidemenu_SideMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_sidemenu_SideMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Landing2__ = __webpack_require__(1680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Landing2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_Landing2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_landingSwiper_magazines_vue__ = __webpack_require__(1677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_landingSwiper_magazines_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_landingSwiper_magazines_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_landingSwiper_novels_vue__ = __webpack_require__(1678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_landingSwiper_novels_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_landingSwiper_novels_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_landingSwiper_children_vue__ = __webpack_require__(1676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_landingSwiper_children_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_landingSwiper_children_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_ViewContent__ = __webpack_require__(1683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_ViewContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_ViewContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_ViewAll__ = __webpack_require__(1682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_ViewAll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_ViewAll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_MyAccount__ = __webpack_require__(1681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_MyAccount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_MyAccount__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_landingSwiper_No1_Majalah_vue__ = __webpack_require__(1671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_landingSwiper_No1_Majalah_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_landingSwiper_No1_Majalah_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_landingSwiper_No2_Fiksyen_vue__ = __webpack_require__(1672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_landingSwiper_No2_Fiksyen_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_landingSwiper_No2_Fiksyen_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_landingSwiper_No3_Agama_vue__ = __webpack_require__(1673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_landingSwiper_No3_Agama_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_landingSwiper_No3_Agama_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_landingSwiper_No4_BukanFiksyen_vue__ = __webpack_require__(1674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_landingSwiper_No4_BukanFiksyen_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_landingSwiper_No4_BukanFiksyen_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_landingSwiper_No5_Kanak_vue__ = __webpack_require__(1675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_landingSwiper_No5_Kanak_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_landingSwiper_No5_Kanak_vue__);



















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component("App-SideMenu", __WEBPACK_IMPORTED_MODULE_4__components_sidemenu_SideMenu___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component("App-Magazines", __WEBPACK_IMPORTED_MODULE_6__components_landingSwiper_magazines_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component("App-Novel", __WEBPACK_IMPORTED_MODULE_7__components_landingSwiper_novels_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component("App-Children", __WEBPACK_IMPORTED_MODULE_8__components_landingSwiper_children_vue___default.a);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component("App-No1Majalah", __WEBPACK_IMPORTED_MODULE_12__components_landingSwiper_No1_Majalah_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component("App-No2Fiksyen", __WEBPACK_IMPORTED_MODULE_13__components_landingSwiper_No2_Fiksyen_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component("App-No3Agama", __WEBPACK_IMPORTED_MODULE_14__components_landingSwiper_No3_Agama_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component("App-No4BukanFiksyen", __WEBPACK_IMPORTED_MODULE_15__components_landingSwiper_No4_BukanFiksyen_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component("App-No5Kanak", __WEBPACK_IMPORTED_MODULE_16__components_landingSwiper_No5_Kanak_vue___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    // mode: 'history',
    mode: 'hash',
    base: __dirname,
    routes: [{
        name: 'landing',
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_5__views_Landing2___default.a
    }, {
        name: 'viewContent',
        path: '/viewContent',
        component: __WEBPACK_IMPORTED_MODULE_9__views_ViewContent___default.a
    }, {
        name: 'ViewAll',
        path: '/ViewAll',
        component: __WEBPACK_IMPORTED_MODULE_10__views_ViewAll___default.a
    }, {
        name: 'login',
        path: '/login',
        component: __WEBPACK_IMPORTED_MODULE_2__views_login___default.a
    }, {
        name: 'MyAccount',
        path: '/MyAccount',
        component: __WEBPACK_IMPORTED_MODULE_11__views_MyAccount___default.a
    },
    /*{
        name: 'register',
        path: '/register',
        component: Register
    },*/
    {
        path: '*',
        redirect: ''
    }]
}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),

/***/ 566:
/***/ (function(module, exports) {

/*import Firebase from 'firebase'

var config = {
  apiKey: "AIzaSyDh_iJ9unAGod960qYWztY20gJeq0Gvx28",
  databaseURL: "https://myneighby-d3918.firebaseio.com/",
  projectId: "myneighby-d3918",
  storageBucket: 'gs://myneighby-d3918.appspot.com'
}
const firebaseApp = Firebase.initializeApp(config)
export const db = firebaseApp.database()
export const auth = firebaseApp.auth()
export const storage = firebaseApp.storage()*/

/***/ }),

/***/ 567:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_C_Users_user_Desktop_YBR_node_modules_babel_runtime_core_js_promise__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_C_Users_user_Desktop_YBR_node_modules_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_C_Users_user_Desktop_YBR_node_modules_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(230);






__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = ({
  post: function post(nodeAddress, data, hideLoader) {
    var _this = this;

    return new __WEBPACK_IMPORTED_MODULE_0_C_Users_user_Desktop_YBR_node_modules_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var api = __WEBPACK_IMPORTED_MODULE_4____["a" /* default */].base + nodeAddress;
      var token = _this.getUserToken();
      if (!hideLoader) {
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit("loading", true);
      }
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.post(api, data, {
        headers: { "Content-Type": "application/json", "token": token },
        timeout: 30000
      }).then(function (res) {
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit("loading", false);
        resolve(res);
      }, function (err) {
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit("loading", false);
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit("error", err.body);
        // if (err.ok === false) {
        //     this.handleRefreshToken()
        // }
        reject(err);
      });
    });
  },
  patch: function patch(nodeAddress, data, hideLoader) {
    var _this2 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_C_Users_user_Desktop_YBR_node_modules_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var api = __WEBPACK_IMPORTED_MODULE_4____["a" /* default */].base + nodeAddress;
      var token = _this2.getUserToken();
      if (!hideLoader) {
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit("loading", true);
      }
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.patch(api, data, {
        headers: { "Content-Type": "application/json", "token": token },
        timeout: 30000
      }).then(function (res) {
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit("loading", false);
        resolve(res);
      }, function (err) {
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit("loading", false);
        // if (err.ok === false) {
        //     this.handleRefreshToken()
        // }
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit("error", err.body);
        reject(err);
      });
    });
  },
  get: function get(nodeAddress, data, hideLoader) {
    var _this3 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_C_Users_user_Desktop_YBR_node_modules_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var api = __WEBPACK_IMPORTED_MODULE_4____["a" /* default */].base + nodeAddress;
      var token = _this3.getUserToken();
      if (!hideLoader) {
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit("loading", true);
      }
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get(api, {
        headers: {
          "token": token
        },
        timeout: 30000
      }).then(function (res) {
        resolve(res);
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit("loading", false);
      }, function (err) {
        reject(err);
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit("loading", false);
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit("error", err.body);

        // if (err.ok === false) {
        //     this.handleRefreshToken()
        // }
      });
    });
  },
  delete: function _delete(nodeAddress, hideLoader) {
    var _this4 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_C_Users_user_Desktop_YBR_node_modules_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var api = __WEBPACK_IMPORTED_MODULE_4____["a" /* default */].base + nodeAddress;
      var token = _this4.getUserToken();
      if (!hideLoader) {
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit("loading", true);
      }
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.delete(api, {
        headers: { "Content-Type": "application/json", "token": token },
        timeout: 30000
      }).then(function (res) {
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit("loading", false);
        resolve(res);
      }, function (err) {
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit("loading", false);
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit("error", err.body);

        // if (err.ok === false) {
        //     this.handleRefreshToken()
        // }
        reject(err);
      });
    });
  },
  getUserToken: function getUserToken() {
    if (__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.user && __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.user.token) {
      return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.user.token;
    } else {
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit("user", JSON.parse(localStorage.getItem("authData")));
      return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.user.token;
    }
  }
});

/***/ }),

/***/ 568:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_request__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_firebase__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__services_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);





var R = __webpack_require__(1509);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

var http = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http;

/* harmony default export */ __webpack_exports__["a"] = ({
    setBookName: function setBookName(_ref, payload) {
        var commit = _ref.commit;

        commit('setBookName', payload);
    },
    setBookImg: function setBookImg(_ref2, payload) {
        var commit = _ref2.commit;

        commit('setBookImg', payload);
    },
    setDeviceType: function setDeviceType(_ref3, payload) {
        var commit = _ref3.commit;

        commit('setDeviceType', payload);
    }
});

/***/ }),

/***/ 569:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


/* harmony default export */ __webpack_exports__["a"] = ({
    //idState: { name: [" "] },
    setBookName: function setBookName(state, payload) {
        state.idState.name = payload;
    },
    setDeviceType: function setDeviceType(state, payload) {
        state.deviceType.platfrom = payload;
    }
});

/***/ })

},[564]);


// WEBPACK FOOTER //
// client.4a971beb.js